import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconDropdown from 'assets/icons/icon-dropdown-white.svg';
import './Accordion.scss';

const Accordion = ({
  level, title, content, isOpen, onAccordionToggle, isCompleted, isHidden = false,
}) => {
  const accordionClass = classNames({
    'nw-accordion--open': isOpen,
    'nw-accordion': true,
    'nw-accordion--hidden': isHidden,
  });

  return (
    <div className={accordionClass}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/no-static-element-interactions */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <header className="nw-accordion__header" onClick={onAccordionToggle}>
        {/* <div className="nw-accordion__top">
          <div className="nw-accordion__category">{category}</div>
          <FontAwesomeIcon icon="chevron-down" />
        </div> */}
        <span className={`nw-accordion__header__num ${isCompleted ? 'nw-accordion__header__num--completed' : ''}`}>{isCompleted ? <em /> : level}</span>
        <strong className="nw-accordion__header__title">{title}</strong>
        <img className="dropdown" src={IconDropdown} alt={title} />
      </header>
      <div className="nw-accordion__content">{content}</div>
    </div>
  );
};

Accordion.propTypes = {
  /** accordion no. */
  level: PropTypes.string,
  /** accordion title */
  title: PropTypes.string,
  /** accordion description */
  content: PropTypes.node,
  /** accordion open state */
  isOpen: PropTypes.bool,
  /** accordion toggle action */
  onAccordionToggle: PropTypes.func,
  /** is section completed - to show checkmark */
  isCompleted: PropTypes.bool,
};

Accordion.defaultProps = {
  level: 'I',
  title: '',
  content: null,
  isOpen: false,
  onAccordionToggle: () => {},
  isCompleted: false,
};

export default Accordion;
